<div class="bulk-actions-footer" data-region="bulkActionsRegion"></div>
<div class="pager-footer" data-region="pagerRegion"></div>